export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14268.e40c19cd.jpg";